"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.function.name.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactCodemirror = _interopRequireDefault(require("@uiw/react-codemirror"));
var _formElements = require("@evidation/form-elements");
var _codemirrorThemeTokyoNight = require("@uiw/codemirror-theme-tokyo-night");
var _codemirrorExtensionsLangs = require("@uiw/codemirror-extensions-langs");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CodeArea = function CodeArea(_ref) {
  var _input$value;
  var labelStyle = _ref.labelStyle,
    label = _ref.label,
    required = _ref.required,
    meta = _ref.meta,
    input = _ref.input,
    config = _ref.config,
    lang = _ref.lang;
  var _useState = (0, _react.useState)(((_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value[input.name]) || config.defaultValue || ''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    studyData = _useState2[0];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    extensions = _useState6[0],
    setExtensions = _useState6[1];
  (0, _react.useEffect)(function () {
    if (_codemirrorExtensionsLangs.langs[lang]) {
      setExtensions([_codemirrorExtensionsLangs.langs[lang]()]);
    } else {
      console.error("".concat(lang, " not supported, using default lang instead"));
      setExtensions([_codemirrorExtensionsLangs.langs['css']()]);
    }
  }, [lang]);
  (0, _react.useEffect)(function () {
    var touched = meta.touched,
      validationError = meta.error;
    if (touched && validationError) {
      setError(validationError);
    }
  }, [meta, setError]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    labelStyle: labelStyle,
    label: label,
    required: required
  }, /*#__PURE__*/_react["default"].createElement(_reactCodemirror["default"], {
    theme: _codemirrorThemeTokyoNight.tokyoNight,
    value: studyData,
    height: "400px",
    extensions: extensions,
    onChange: function onChange(val) {
      return input.onChange(val);
    }
  })), error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error));
};
var _default = exports["default"] = CodeArea;